import React, {useEffect} from 'react';
import {Box, Grid, Link} from '@mui/material';
import contactUs from '../assets/contact_pic.png';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

export const ContactUs = () => {

	useEffect(() => {
		const script = document.createElement('script');
		script.id = '21211fbf-4bb5-438f-a2c3-a2df85151da7';
		script.setAttribute('data-yt-url', 'https://hopsoft.youtrack.cloud');
		script.src = 'https://hopsoft.youtrack.cloud/static/simplified/form/form-entry.js';
		script.setAttribute('data-theme', 'light');
		script.setAttribute('data-lang', 'en');

		document.getElementById("youtrack-script").appendChild(script);

		return () => {
			const scriptElement = document.getElementById('21211fbf-4bb5-438f-a2c3-a2df85151da7');
			if (scriptElement) {
				scriptElement.remove();
			}
		};
	}, []);
	return (
		<Container maxWidth="lg">
			<div id={'mainPanel'}/>
			<Grid container spacing={5} paddingTop={5} paddingBottom={4}>
				<Grid item xs={0} md={5} sx={{display: {xs: 'none', md: 'flex'}, alignItems: 'flex-start'}}>
					<Box component="img" src={contactUs} alt="Contact Us"
					     sx={{width: '100%', height: 'auto', objectFit: 'contain', borderRadius: 3}}/>
				</Grid>
				<Grid item xs={12} md={7}>
					<Typography component="h2" sx={{
						fontWeight: 800,
						color: '#58595b',
						fontSize: {xs: '1.6rem', md: '2rem'},
						letterSpacing: '0.02em',
					}}>
						CONTACT US
					</Typography>
					<Box sx={{width: '64px', height: '4px', backgroundColor: 'primary.main', borderRadius: 2, marginTop: 1, marginBottom: 3}}/>
					<Typography sx={{paddingBottom: 3}}>
						For technical support of our products please email us on <Link
						color="text.primary"
						href={`mailto:support@hopsoft.com.au`}
						underline="hover">
						support@hopsoft.com.au
					</Link> or use the form below.
					</Typography>
					<Box sx={{
						maxWidth: '560px',
						backgroundColor: '#ffffff',
						border: 2,
						borderColor: '#e0dcdc',
						borderRadius: 3,
						padding: {xs: 2, sm: 3},
					}}>
						<div id="youtrack-script">
							{/* This is where the form will be inserted */}
						</div>
					</Box>
				</Grid>
			</Grid>
		</Container>
	);
};
